<script>
import mixin from '@/plans/mx/shopping-cart';
import { isZoomSchedulerAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';

export default {
  mixins: [mixin],
  name: 'SchedulerCart',
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  methods: {
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            {
              /* FREE TRIAL - Specific UI for free trial */
            }
            if (!!plan.isOnlineFreeTrial && !!plan.trialDays) {
              return (
                <div>
                  {this.mx_freeTrialTitle(this.$t('billing.scheduler.title'))}
                  {this.mx_license(plan.cartInfo.selected_number)}
                  {this.mx_freeTrialDesc(plan.trialDays)}
                  {this.mx_discount(plan.plan_code)}
                  {this.mx_cycle(plan.billing_cycle)}
                  {this.mx_edit(plan)}
                  {(!this.mx_isLastBasePlan || isZoomSchedulerAsAddonCard()) && this.mx_remove(plan)}
                </div>
              );
            }
            return (
              <div>
                {this.mx_title(
                  this.$t('billing.scheduler.title'),
                  <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>,
                )}
                <AltProratedPlanUser type={plan.type}>
                  {this.mx_license(plan.cartInfo.selected_number)}
                </AltProratedPlanUser>
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                <AltProratedPlanPeriod type={plan.type} />
                {this.mx_edit(plan)}
                {(!this.mx_isLastBasePlan || isZoomSchedulerAsAddonCard()) && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
    $renderTip() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>
